import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_t9ve76j393: FaireBrandEntity = {
  token: "b_t9ve76j393",
  type: "brand",
  name: "CaNatureLover",
  avatarUrl:
    "https://cdn.faire.com/fastly/8cd8ecc75020294e7e6e522e62d1d341f6161397ad4ed9b9ca53bc1479e74938.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/5cc6083f71e9c0980cbafa2499779e80afe6a94c0b7917b3d7d1dd142588a3ac.png",
  logoUrl:
    "https://cdn.faire.com/fastly/8cd8ecc75020294e7e6e522e62d1d341f6161397ad4ed9b9ca53bc1479e74938.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5cc6083f71e9c0980cbafa2499779e80afe6a94c0b7917b3d7d1dd142588a3ac.png",
  location: "North Hollywood, CA, USA",
  minimumOrderDollars: 75,
  rating: 4.8,
  reviewCount: 404,
  isInsider: true,
  description:
    'A family-owned shop from California dedicated to sharing their love to nature across the globe\nHello there, thank you for visiting our shop. We are a family located here in California, which explains the name of our store CA "California" Nature Lover.\n\nOur office is in the heart of Los Angeles, where we are completely committed and enthusiastic about protecting these magnificent and precious medicines from mother nature and grandmother Earth. We do it as a family, with our eyes set on the future for our children, your families, and future generations. Thank you for standing up for small, devoted shops and families like ours and refusing giant, commercial, unsustainable businesses which try to swallow small shops.\n\nWe appreciate your visit. Please let us know if you have any questions or think there is anything we could improve. We love to hear from our nature lovers and are always open to ideas. May peace and love be with you!',
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:30.751Z",
    importedBy: "entity-db-cli",
  },
};
